"use strict";
// import "gatsby-prismjs-dracula";
import "./src/styles/global.css";
require("./src/assets/scss/init.scss");
// require('./static/css/prismjs/theme.min.css');

// require("prismjs/plugins/command-line/prism-command-line.css")
require("prism-themes/themes/prism-material-oceanic.css");
